import { Observable } from 'rxjs';
import { CatalogSearchResponse } from './model';

export interface ApiResponse<T = unknown> {
    data: T;
    success?: boolean;
    message?: string;
}

export abstract class CatalogRepository {
    abstract searchCatalog(
        uid: string,
        cid: string | null,
        query?: string,
        page?: number,
        limit?: number,
        type?: string,
        onlyEnabled?: boolean
    ): Observable<ApiResponse<CatalogSearchResponse>>;
}
